import { Component, OnInit } from '@angular/core';
import { clickGAEvent } from 'src/app/_helpers/ga-events';
import { Router } from '@angular/router';
import { pageLoadEvent } from 'src/app/_helpers/ga-events';
import {
  addGAEventListener,
  removeGAEventListener,
} from 'src/app/_helpers/ga-events';
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'tp-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css'],
})
export class ResetComponent implements OnInit {
  validateForm!: UntypedFormGroup;
  submitted = false;
  passwordVisible: boolean = false;
  passwordVisible2: boolean = false;

  constructor(private fb: UntypedFormBuilder, private router: Router) {}

  ngOnInit() {
    pageLoadEvent('auth-reset-password_page');
    addGAEventListener();
    this.validateForm = this.fb.group({
      password: [null, [Validators.required, Validators.minLength(9)]],
      repassword: [null, [Validators.required, Validators.minLength(9)]],
    });
  }

  ngAfterViewInit(): void {
    removeGAEventListener();
    addGAEventListener();
  }

  ngOnDestroy(): void {
    removeGAEventListener();
  }

  get f() {
    return this.validateForm.controls;
  }

  submitForm() {
    this.submitted = true;
    if (this.validateForm.valid) {
      // console.log('submit', this.validateForm.value);
    } else {
      Object.values(this.validateForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  togglePasswordVisibility() {
    clickGAEvent(
      'show_password',
      'resetpswd-password-visibility_click',
      'auth-reset-password_page'
    );
    this.passwordVisible = !this.passwordVisible;
  }

  togglePasswordVisibility2() {
    this.passwordVisible2 = !this.passwordVisible2;
  }

  triggerGAInput(inputName: string): void {
    clickGAEvent(
      'input_text',
      'resetpswd-' + inputName,
      'auth-reset-password_page'
    );
  }
  triggerGAButton(buttonName: string): void {
    if (buttonName === 'back-to-login') {
      clickGAEvent(
        'button_click',
        buttonName + '_click',
        'auth-reset-password_page'
      );
      this.router.navigate(['/auth/login']);
    }
    if (buttonName === 'reset-password') {
      clickGAEvent(
        'button_click',
        buttonName + '_click',
        'auth-reset-password_page'
      );
    }
  }
}
